import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

const ToggleAlertLink = ({ actionLink, actionTitle, isError, title, iconClass }) => {
  return (
    <div className={`card-header d-flex justify-content-between mb-1 align-items-center ${isError && "error"}`}>
      <span>
        <i className={iconClass}></i>
        {title}
      </span>
      <div className="d-flex justify-content-center align-items-center">
        <div>
          <NavLink to={actionLink}>{actionTitle}</NavLink>
        </div>
      </div>
    </div>
  );
};

ToggleAlertLink.propTypes = {
  iconClass: PropTypes.string,
  title: PropTypes.string,
  actionTitle: PropTypes.string,
  actionLink: PropTypes.func,
  isError: PropTypes.bool,
};

export default ToggleAlertLink;
